import { BaseApiFacade } from '@emcd-shared/api-service'
import {
  requestErrorInterceptor,
  requestInterceptor,
  responseErrorInterceptor,
  responseInterceptor,
} from '@/packages/auth-service/api'
import { businessErrorInterceptor } from '@/shared/api/interceptors'
import CONFIG from '@/app/config/config'
import store from '@/app/store'

export class ApiFacade extends BaseApiFacade {
  constructor(app) {
    super()

    // eslint-disable-next-line no-restricted-syntax
    const saveDataCallBack = (res) => {
      store.dispatch('auth/authenticate', res)
    }

    this.setupInterceptors(this.client, app, saveDataCallBack)
    this.setupInterceptors(this.endpointApi, app, saveDataCallBack)
    this.setupInterceptors(this.emcdApi, app, saveDataCallBack)

    this.createGate(CONFIG.AUTH_API_URL, 'authApi', app, saveDataCallBack)
    this.createGate(CONFIG.POOL_API_URL, 'poolApi', app, saveDataCallBack)
  }

  createGate(url, key, app, saveDataCallBack) {
    if (url) {
      this[key] = this.create(url)
      this.setupInterceptors(this[key], app, saveDataCallBack)
    }
  }

  setupInterceptors(gate, app, saveDataCallBack) {
    gate.client.interceptors.request.use(
      requestInterceptor,
      requestErrorInterceptor
    )
    gate.client.interceptors.response.use(
      responseInterceptor,
      responseErrorInterceptor(this.endpointApi.client, saveDataCallBack, app)
    )
    gate.client.interceptors.response.use(null, businessErrorInterceptor(store))
  }
}

export const ApiService = ApiFacade

export default ApiService
